export function TiremetrixRegisterTiresCtrl (
  $scope,
  $uibModalInstance,
  $translate,
  workshopAPI,
  sessionObjAPI,
  messages,
  invoice,
  customer,
  vehicle,
  tires,
  Tiremetrix,
  states
) {
  $scope.states              = states;
  $scope.regoLabel           = sessionObjAPI.countrySettings().rego_label;
  $scope.invoice             = invoice;

  $scope.registration = {
    invoice: invoice,
    customer: customer,
    vehicle: vehicle,
    tires: tires
  };

  $scope.Tiremetrix = new Tiremetrix();

  $scope.process = function () {
    $scope.Tiremetrix.processRegistration($scope.invoice, $scope.registration).then(() => {
      messages.show($translate.instant('TIREMETRIX_SPACE.TYRE_REGISTRATIONS_SENT'), 'success');

      $uibModalInstance.close($scope.invoice);
    }).catch(err => {
      messages.error(err);
    });
  };
}